import { useState } from 'react';
import { Button, Tab } from 'react-bootstrap';
import { PageBody } from '../SiteWrapper';
import PageHeaderActions from '../General/PageHeaderActions';

const TabLayout = ({ tabs, defaultIndex = 0, firstTabMarginZero = false }) => {
  const [activeIndex, setActiveIndex] = useState(defaultIndex);

  return (
    <div>
      <div className='bg-white my-3 mx-3 shadow-rrb rounded-3'>
        <PageHeaderActions
          title='Incident Monitoring'
          cardHeaderClassName='px-3'
        />
        <hr className='m-0' />

        <div className='d-flex justify-content-between pe-3 align-items-center'>
          <div className='d-flex border-b px-3 gap-3 overflow-scroll '>
            {tabs.map((tab, index) => (
              <Button
                variant='none'
                key={tab.label}
                onClick={() => setActiveIndex(index)}
                className={`px-0 border-0  border-2  rounded-0 ${
                  activeIndex === index
                    ? 'font-semibold text-primary border-bottom border-bottom-2 border-primary'
                    : 'text-secondary'
                } shadow-none`}
                style={{
                  borderBottom:
                    activeIndex === index
                      ? '2px solid #007bff !important'
                      : 'none',
                  paddingBottom: '10px',
                  paddingTop: '10px',
                }}
              >
                {tab.label}
              </Button>
            ))}
          </div>
          <div></div>
        </div>
        <hr className='m-0' />
        <PageBody>
          {/* Tab Content */}
          <div className=''>{tabs[activeIndex].content}</div>
        </PageBody>
      </div>
    </div>
  );
};

export default TabLayout;
